import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { queryClient } from '@core/queryClient';
import { I18nProvider } from '@core/i18n';
import { GroupAnalyticsProvider, RouteTracker } from '@core/analytics';
import { GroupLandingPage } from '@features/groups';

/**
 * Entry for the group-landing host (go.meitre.com).
 * Tenant-less: NO TenantProvider/TenantGuard/BookingProvider — a group page
 * is not a single restaurant. Mounts only what a landing needs.
 *
 * Provider tree (minimal):
 *   QueryClientProvider  — server-state cache
 *   I18nProvider         — safe tenant-less (uses LanguageDetector → localStorage/navigator)
 *   GroupAnalyticsProvider — GA4 via shared Meitre GA ID, no restaurant context
 *   BrowserRouter        — routing (after analytics so RouteTracker sees real history)
 */
export function GroupApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <GroupAnalyticsProvider>
          <BrowserRouter>
            <RouteTracker />
            <Routes>
              <Route path="/:slug" element={<GroupLandingPage />} />
            </Routes>
          </BrowserRouter>
        </GroupAnalyticsProvider>
      </I18nProvider>
    </QueryClientProvider>
  );
}

export default GroupApp;
